module.exports = __webpack_public_path__ + "media/images/lb/353-ae3e6f72dc1570a3a70f6e10a901dd46.svg";